import { useEffect, useState } from 'react'
import clsx from 'clsx'

/* blocks */
import Link from '@/atoms/Link/Link'

/* utils */
import { HeaderProps as Props } from './Header.utils'

/* assets */
import { ReactComponent as PepperLogo } from 'public/assets/icons/PepperLogo_White.svg'

/* styling */
import styles from './mobile.module.css'

const MEDIUM_SCREEN_SIZE = 768

function MobileHeader({
  showNavLinks = true,
  className,
  primaryCta
}: Props): JSX.Element {
  const [menuVisibility, setMenuVisibility] = useState(false)
  const [activeAccordion, setActiveAccordion] = useState<string | number>()

  useEffect(() => {
    if (menuVisibility) {
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.classList.remove('overflow-hidden')
      setActiveAccordion('')
    }
  }, [menuVisibility])

  useEffect(() => {
    // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/#css-custom-properties-the-trick-to-correct-sizing
    const getViewportHeight = () => {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }

    getViewportHeight()

    if (window.innerWidth <= MEDIUM_SCREEN_SIZE) {
      window.addEventListener('resize', getViewportHeight)
    }
    return () => window.removeEventListener('resize', getViewportHeight)
  }, [])

  const toggleNav = () => setMenuVisibility(!menuVisibility)

  const closeMenu = () => setMenuVisibility(false)

  return (
    <section
      className={clsx(
        'bg-blue-web-90 text-white | sticky top-0  |  h-18  |  px-5 mx-auto  |  z-50',
        menuVisibility && 'active',
        className
      )}
    >
      <div className="flex justify-between items-center | h-full">
        {showNavLinks ? (
          <Link href="/" title="Homepage" onClick={() => closeMenu()}>
            <PepperLogo style={{ width: 110, height: 33 }} />
          </Link>
        ) : (
          <PepperLogo style={{ width: 110, height: 33 }} />
        )}

        <div
          className={clsx(
            styles.hamburgerDarkBg,
            menuVisibility && 'active',
            !showNavLinks && 'hidden'
          )}
          role="button"
          aria-label="Toggle Navigation"
          tabIndex={0}
          id="hamburger"
          onClick={toggleNav}
          onKeyPress={toggleNav}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      {/* menu items */}
      <nav
        className={clsx(
          'bg-blue-web-90 | select-none | z-50 | overflow-y-auto',
          menuVisibility && 'active',
          styles.mobileNavDropdown
        )}
      >
        <Link
          href="#agenda"
          className={clsx('font-heading', styles.menuItem)}
          onClick={() => closeMenu()}
        >
          Agenda
        </Link>
        <Link
          href="#speakers"
          className={clsx('font-heading', styles.menuItem)}
          onClick={() => closeMenu()}
        >
          Speakers
        </Link>
        <Link
          href="#faq"
          className={clsx('font-heading', styles.menuItem)}
          onClick={() => closeMenu()}
        >
          FAQ
        </Link>
        <Link
          href="#contact"
          className={clsx('font-heading', styles.menuItem)}
          onClick={() => closeMenu()}
        >
          Contact Us
        </Link>

        <div
          className={clsx(
            'grid grid-cols-1 md:grid-cols-2 justify-items-stretch gap-4 | fixed bottom-6 left-5 right-5  |  transition-all',
            activeAccordion && 'translate-y-20 | opacity-0 | invisible'
          )}
        >
          {primaryCta ? (
            <Link
              href={primaryCta.url}
              className="bg-linear-to-r from-[#1600E5] to-[#4B77F2] flex justify-center items-center gap-2 whitespace-nowrap text-sm font-medium rounded-lg py-2 px-10 w-full md:w-auto"
              onClick={() => closeMenu()}
            >
              {primaryCta.title}
            </Link>
          ) : null}
        </div>
      </nav>
    </section>
  )
}

export default MobileHeader
